<div class="h-full flex flex-col overflow-visible">
    <div
        class="shrink-0 flex flex-row gap-x-4 items-center justify-between w-full border-b border-zinc-200 dark:border-zinc-800 pb-2 overflow-visible">
        <div class="shrink-0 flex flex-row items-center justify-start gap-x-2">
            <button type="button" class="inline-flex items-center gap-x-1.5 btn-shout btn-shout-xs btn-shout-primary">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="-ml-0.5 size-5">
                    <path d="M16.75 12h3.632a1 1 0 0 1 .894 1.447l-2.034 4.069a1 1 0 0 1-1.708.134l-2.124-2.97" />
                    <path
                        d="M17.106 9.053a1 1 0 0 1 .447 1.341l-3.106 6.211a1 1 0 0 1-1.342.447L3.61 12.3a2.92 2.92 0 0 1-1.3-3.91L3.69 5.6a2.92 2.92 0 0 1 3.92-1.3z" />
                    <path d="M2 19h3.76a2 2 0 0 0 1.8-1.1L9 15" />
                    <path d="M2 21v-4" />
                    <path d="M7 9h.01" />
                </svg>
                Monitoring Home
            </button>

        </div>

        <div class="flex-1 flex flex-row items-center justify-end gap-x-2">
            <nav aria-label="Tabs" class="flex space-x-2">
                <a (click)="selectedTab.set('monitoring-home')"
                    class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                    [class]="getTabClass('monitoring-home')">Monitoring Home</a>
                <a (click)="selectedTab.set('creator-lists')"
                    class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                    [class]="getTabClass('creator-lists')">Creator Lists</a>
                <a (click)="selectedTab.set('monitoring-briefs')"
                    class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                    [class]="getTabClass('monitoring-briefs')">Monitoring Briefs</a>
            </nav>
        </div>
    </div>

    <div class="h-full flex-1 flex-col items-center justify-center w-full overflow-hidden space-y-4 py-4">

        @switch (selectedTab()) {
        @case ('monitoring-home') {
        <!-- Social Monitoring - Get Started -->
        <div
            class="w-full divide-y divide-gray-100 dark:divide-white/10 overflow-hidden shadow-card-container-pale flex flex-col max-h-full">
            <div class="shrink-0 p-2 flex flex-wrap items-center justify-between sm:flex-nowrap">

                <div class="flex items-center">
                    <div class="shrink-0">
                        <div
                            class="size-10 rounded-xl bg-primary/20 text-accent text-sm font-semibold flex items-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-6">
                                <path
                                    d="M16.75 12h3.632a1 1 0 0 1 .894 1.447l-2.034 4.069a1 1 0 0 1-1.708.134l-2.124-2.97" />
                                <path
                                    d="M17.106 9.053a1 1 0 0 1 .447 1.341l-3.106 6.211a1 1 0 0 1-1.342.447L3.61 12.3a2.92 2.92 0 0 1-1.3-3.91L3.69 5.6a2.92 2.92 0 0 1 3.92-1.3z" />
                                <path d="M2 19h3.76a2 2 0 0 0 1.8-1.1L9 15" />
                                <path d="M2 21v-4" />
                                <path d="M7 9h.01" />
                            </svg>
                        </div>

                    </div>
                    <div class="ml-4">
                        <h3 class="text-md font-semibold text-primary">Social Monitoring</h3>
                        <p class="text-sm text-secondary">
                            How would you like to monitor social content?
                        </p>
                    </div>
                </div>

                <div class="flex shrink-0 flex-row items-center justify-end gap-x-2">
                    <button type="button"
                        class="inline-flex min-h-11 min-w-min items-center gap-2 rounded-lg px-1 text-sm font-medium text-zinc-200 transition hover:text-white">
                        <svg class="size-4 shrink-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            aria-hidden="true">
                            <path d="m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5" />
                            <rect x="2" y="6" width="14" height="12" rx="2" />
                        </svg>
                        How to start
                    </button>
                </div>
            </div>

            <div class="flex-1 flex flex-col px-2 py-2 overflow-hidden">
                <ul role="list" class="grid grid-cols-1 gap-5 sm:grid-cols-3 sm:gap-6">
                    @for (card of toolCards; track card.label) {
                    <li
                        class="divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow-sm dark:divide-white/10 dark:bg-gray-800/50 dark:shadow-none dark:outline dark:-outline-offset-1 dark:outline-white/10">
                        <div class="p-4">
                            <div class="flex">
                                <div class="shrink-0">
                                    <span
                                        class="flex size-10 shrink-0 items-center justify-center rounded-lg bg-linear-to-br text-white shadow-inner {{ card.gradient }}">
                                        @switch (card.icon) {
                                        @case ('deliverables') {
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round">
                                            <path
                                                d="M10.5 22H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.706.706l3.588 3.588A2.4 2.4 0 0 1 20 8v6" />
                                            <path d="M14 2v5a1 1 0 0 0 1 1h5" />
                                            <path d="m14 20 2 2 4-4" />
                                        </svg>
                                        }
                                        @case ('safety') {
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round">
                                            <path
                                                d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
                                            <path d="m9 12 2 2 4-4" />
                                        </svg>
                                        }
                                        @case ('topic') {
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round">
                                            <line x1="4" x2="20" y1="9" y2="9" />
                                            <line x1="4" x2="20" y1="15" y2="15" />
                                            <line x1="10" x2="8" y1="3" y2="21" />
                                            <line x1="16" x2="14" y1="3" y2="21" />
                                        </svg>
                                        }
                                        @case ('film') {
                                        <svg class="size-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" aria-hidden="true">
                                            <rect width="18" height="18" x="3" y="3" rx="2" />
                                            <path d="M7 3v18" />
                                            <path d="M3 7.5h4" />
                                            <path d="M3 12h18" />
                                            <path d="M3 16.5h4" />
                                            <path d="M17 3v18" />
                                            <path d="M17 7.5h4" />
                                            <path d="M17 16.5h4" />
                                        </svg>
                                        }
                                        @case ('video') {
                                        <svg class="size-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" aria-hidden="true">
                                            <path
                                                d="m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5" />
                                            <rect x="2" y="6" width="14" height="12" rx="2" />
                                        </svg>
                                        }
                                        @case ('expand') {
                                        <svg class="size-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" aria-hidden="true">
                                            <path d="M15 3h6v6" />
                                            <path d="M9 21H3v-6" />
                                            <path d="M21 3v5a2 2 0 0 1-2 2H9" />
                                            <path d="M3 21v-5a2 2 0 0 1 2-2h10" />
                                        </svg>
                                        }
                                        @case ('mic') {
                                        <svg class="size-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" aria-hidden="true">
                                            <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z" />
                                            <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
                                            <line x1="12" x2="12" y1="19" y2="22" />
                                        </svg>
                                        }
                                        @case ('pencil') {
                                        <svg class="size-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" aria-hidden="true">
                                            <rect width="18" height="18" x="3" y="3" rx="2" />
                                            <path d="M8 19s1.5-1 2.5-3 2-1 2-1" />
                                            <path d="M12 8h.01" />
                                            <path d="M15 11h.01" />
                                        </svg>
                                        }
                                        }
                                    </span>
                                </div>
                                <div class="ml-3">
                                    <h3 class="text-sm font-medium text-primary">{{ card.label
                                        }}</h3>
                                    <div class="text-sm text-secondary">
                                        <p>{{ card.description }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="p-2 flex flex-row items-center justify-end">
                            <button (click)="startMonitoring(card.label)" type="button" class="inline-flex items-center gap-x-1.5 btn-shout btn-shout-xs btn-shout-primary">
                                Start Monitoring
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="-mr-0.5 size-5">
                                    <path d="M5 12h14" />
                                    <path d="m12 5 7 7-7 7" />
                                </svg>
                            </button>
                        </div>
                    </li>
                    }
                </ul>
            </div>
        </div>
        <!-- Social Monitoring - Get Started - END -->

        <!-- Active Monitoring Overview -->
        <mon-active-monitoring-overview></mon-active-monitoring-overview>
        <!-- Active Monitoring Overview - END -->
        }
        @case ('creator-lists') {
            <mon-creator-lists></mon-creator-lists>
        }
        @case ('monitoring-briefs') {
            <mon-monitoring-briefs class="h-full"></mon-monitoring-briefs>
        }
        }

    </div>
</div>